__turbopack_context__.v({
  "highlight": "DashboardSidebar-module__n6osYq__highlight",
  "link": "DashboardSidebar-module__n6osYq__link",
  "logo": "DashboardSidebar-module__n6osYq__logo",
  "nav": "DashboardSidebar-module__n6osYq__nav",
  "navItem": "DashboardSidebar-module__n6osYq__navItem",
  "plate": "DashboardSidebar-module__n6osYq__plate",
  "selected": "DashboardSidebar-module__n6osYq__selected",
  "sidebar": "DashboardSidebar-module__n6osYq__sidebar",
});
